module.exports = __webpack_public_path__ + "static/media/garbage-truck.e39cf5f0.svg";